export const MuiAlert = {
  styleOverrides: {
    root: ({ ownerState }: { ownerState: { severity?: string } }) => {
      // Map severity to appropriate colors
      const severityColors: Record<string, { bg: string; text: string }> = {
        error: {
          bg: "var(--color-red)",
          text: "white",
        },
        success: {
          bg: "var(--color-green)",
          text: "white",
        },
        warning: {
          bg: "var(--color-yellow)",
          text: "black",
        },
        info: {
          bg: "#1976d2", // Material-UI default info blue
          text: "white",
        },
      };

      const severity = ownerState?.severity || "info";
      const colors = severityColors[severity] || severityColors.info;

      return {
        backgroundColor: colors.bg,
        borderRadius: "0",
        fontWeight: "bold",
        fontSize: "1rem",
        color: colors.text,
      };
    },
  },
};
